export function patchModels(defs: any) {
  // injiect the primary key as a required string so that the webapp 
  // will automatically include it in the generated forms
  // even if the model definition do not contain one. Reasons
  // - we don't want useless schema exposed to the testplanapp clients
  // - a unique identifier is needed to handle a collection of item at a backoffice level
  // - we could user a wrapper instead of injiecting but this way we avoid migrations
  Object.keys(defs.__specs__).filter(it => it !== 'conf').forEach(collection => {
    const { primaryModel, primaryKey } = defs.__specs__[collection]
    const schema = defs[collection].definitions[primaryModel]
    schema.properties = {
      [primaryKey]: schema.properties[primaryKey] || { type: "string" },
      ...schema.properties
    }
    schema.required = schema.required || []
    if (!schema.required.includes(primaryKey)) {
      schema.required.unshift(primaryKey)
    }
  })
  return defs
}
